<script setup>
import { computed, ref, watch } from 'vue';

// Props 정의
const props = defineProps({
    modelValue: {
        type: Array,
        default: () => []
    },
    categories: {
        type: Array,
        default: () => []
    },
    inputId: {
        type: String,
        default: ''
    },
    label: {
        type: String,
        default: ''
    },
    required: {
        type: Boolean,
        default: false
    },
    placeholder: {
        type: String,
        default: ''
    },
    disabled: {
        type: Boolean,
        default: false
    },
    marginTop: {
        type: String,
        default: '0'
    },
    marginBottom: {
        type: String,
        default: '0'
    },
    marginLeft: {
        type: String,
        default: '0'
    },
    marginRight: {
        type: String,
        default: '0'
    },
    labelRightmargin: {
        type: String,
        default: '2rem'
    },
    visible: {
        type: Boolean,
        default: true
    },
    readonly: {
        type: Boolean,
        default: false
    },
    errmsg: {
        type: String,
        default: ''
    },
    width: {
        type: String,
        default: '4.5rem'
    }
});

const emit = defineEmits(['update:modelValue', 'change']);
const selectWidth = computed(() => props.width || '10rem');
const selectedValues = ref([...props.modelValue]);
const errMessage = ref(props.errmsg);
const ValidationMsg = ref('');
const isReadonly = computed(() => props.readonly);

watch(
    () => props.errmsg,
    (newVal) => {
        ValidationMsg.value = newVal || '';
        errMessage.value = newVal || '';
    },
    { immediate: true, deep: true }
);

// watch(
//     () => props.modelValue,
//     (newValue) => {
//         selectedValues.value = [...newValue];
//     },
//     { deep: true }
// );

const onChange = (event, category) => {
    const isChecked = event.target.checked;
    let updatedValue = [...selectedValues.value];

    if (isChecked) {
        if (!updatedValue.includes(category.key)) {
            updatedValue.push(category.key);
        }
    } else {
        updatedValue = updatedValue.filter((val) => val !== category.key);
    }

    selectedValues.value = updatedValue;
    emit('update:modelValue', updatedValue);
    emit('change', { id: props.inputId, value: updatedValue });
};

const isChecked = (categoryKey) => {
    return selectedValues.value.includes(categoryKey);
};
</script>

<template>
    <div
        v-if="visible"
        class="flex flex-col"
        :id="inputId"
        :style="{
            marginTop: marginTop,
            marginBottom: marginBottom,
            marginLeft: marginLeft,
            marginRight: marginRight
        }"
    >
        <label :class="['label-font mb-1 mx-1', required ? 'label-required' : 'text-gray-700 dark:text-gray-300']">
            {{ label }}
            <span v-if="required" class="required-asterisk">*</span>
            <span v-if="ValidationMsg" class="validation-message">{{ ValidationMsg }}</span>
        </label>

        <div class="checkbox-container">
            <div v-for="category in categories" :key="category.key" class="checkbox-item">
                <input type="checkbox" :id="`${inputId}-${category.key}`" :value="category.key" :disabled="isReadonly" :checked="isChecked(category.key)" @change="(event) => onChange(event, category)" class="form-checkbox checkbox-input" />
                <label :for="`${inputId}-${category.key}`" class="checkbox-label" :style="{ width: selectWidth }">
                    {{ category.name }}
                </label>
            </div>
        </div>
    </div>
</template>

<style scoped>
.label-font {
    font-family: 'SCoreDream600';
    height: 1.3rem;
    font-size: 0.875rem;
}

.required-asterisk {
    color: #f87171; /* 빨간색 */
    margin-left: 0.2rem;
    position: relative;
    top: -0.2rem;
}

.checkbox-container {
    display: flex;
    flex-wrap: nowrap;
}

.checkbox-item {
    display: flex;
    align-items: center;
    margin-right: 1rem;
    margin-bottom: 0.5rem;
}

.checkbox-label {
    margin-left: 0.2rem;
    margin-top: 0.6rem;
    cursor: pointer;
    font-family: 'SCoreDream500';
    font-size: 0.875rem;
    white-space: nowrap;
}

.checkbox-input {
    cursor: pointer;
    width: 2.5rem; /* 체크박스 높이 증가 */
    height: 1.5rem;
    margin-top: 0.5rem;
}

.error-border {
    border-color: #f87171 !important; /* 빨간색 테두리 */
}
.validation-message {
    color: #f87171; /* red-500 */
    font-size: 0.75rem;
    margin-left: 0.5rem;
}
</style>
